import { render, staticRenderFns } from "./create-miothreshold.vue?vue&type=template&id=4f8d7060&"
import script from "./create-miothreshold.vue?vue&type=script&lang=ts&"
export * from "./create-miothreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports